// removed by extract-text-webpack-plugin
module.exports = {"navigation":"tour-content__navigation___2SeKf"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/tours/tour-content.scss
// module id = 1366
// module chunks = 0